/**
 * main.js
 *
 * @author Christian Seel
 * @version 1.0.0
 * @copyright 2018 SEDA.digital GmbH & Co. KG
 */

if (window.console && console.info) console.info('Welcome to tomorrowlabs') && console.log('Developed by SEDA.digital');

// Dispatch a global event when the main js has been loaded
// this can be used by inlined scripts to know when jQuery is available
window.dispatchEvent(new CustomEvent('jsloaded'));

// replace no-js class with js class
window.document.documentElement.className = window.document.documentElement.className.replace('no-js', 'js');

window.onDCL = function (callback) {
    if (window.document.readyState == "complete" || window.document.readyState == "loaded") {
        callback(); return;
    }
    if (window.addEventListener)
        window.addEventListener('DOMContentLoaded', callback, false);
    else if (window.attachEvent)
        window.attachEvent('onload', callback);
    else window.onload = callback;
};

// Helpers
import helpers from './helpers';
helpers.addEventListeners();

// Modaal
import { Modaal } from 'modaal/dist/js/modaal.js';

// Foundation Framework
import { Foundation } from 'foundation-sites/js/foundation.core';
//import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery'; Foundation.plugin(MediaQuery, 'MediaQuery');
//import { Abide } from 'foundation-sites/js/foundation.abide'; Foundation.plugin(Abide, 'Abide');
//import { Accordion } from 'foundation-sites/js/foundation.accordion'; Foundation.plugin(Accordion, 'Accordion');
//import { AccordionMenu } from 'foundation-sites/js/foundation.accordionMenu'; Foundation.plugin(AccordionMenu, 'AccordionMenu');
//import { Drilldown } from 'foundation-sites/js/foundation.drilldown'; Foundation.plugin(Drilldown, 'Drilldown');
//import { Dropdown } from 'foundation-sites/js/foundation.dropdown'; Foundation.plugin(Dropdown, 'Dropdown');
//import { DropdownMenu } from 'foundation-sites/js/foundation.dropdownMenu'; Foundation.plugin(DropdownMenu, 'DropdownMenu');
//import { Equalizer } from 'foundation-sites/js/foundation.equalizer'; Foundation.plugin(Equalizer, 'Equalizer');
//import { Interchange } from 'foundation-sites/js/foundation.interchange'; Foundation.plugin(Interchange, 'Interchange');
//import { Magellan } from 'foundation-sites/js/foundation.magellan'; Foundation.plugin(Magellan, 'Magellan');
import { OffCanvas } from 'foundation-sites/js/foundation.offcanvas'; Foundation.plugin(OffCanvas, 'OffCanvas');
//import { Orbit } from 'foundation-sites/js/foundation.orbit'; Foundation.plugin(Orbit, 'Orbit');
//import { ResponsiveMenu } from 'foundation-sites/js/foundation.responsiveMenu'; Foundation.plugin(ResponsiveMenu, 'ResponsiveMenu');
//import { ResponsiveToggle } from 'foundation-sites/js/foundation.responsiveToggle'; Foundation.plugin(ResponsiveToggle, 'ResponsiveToggle');
//import { Reveal } from 'foundation-sites/js/foundation.reveal'; Foundation.plugin(Reveal, 'Reveal');
//import { Slider } from 'foundation-sites/js/foundation.slider'; Foundation.plugin(Slider, 'Slider');
//import { SmoothScroll } from 'foundation-sites/js/foundation.smoothScroll'; Foundation.plugin(SmoothScroll, 'SmoothScroll');
//import { Sticky } from 'foundation-sites/js/foundation.sticky'; Foundation.plugin(Sticky, 'Sticky');
//import { Tabs } from 'foundation-sites/js/foundation.tabs'; Foundation.plugin(Tabs, 'Tabs');
//import { Toggler } from 'foundation-sites/js/foundation.toggler'; Foundation.plugin(Toggler, 'Toggler');
//import { Tooltip } from 'foundation-sites/js/foundation.tooltip'; Foundation.plugin(Tooltip, 'Tooltip');
//import { ResponsiveAccordionTabs } from 'foundation-sites/js/foundation.responsiveAccordionTabs'; Foundation.plugin(ResponsiveAccordionTabs, 'ResponsiveAccordionTabs');

// Init Foundation
Foundation.addToJquery(jQuery);
 $(document).foundation();
//Analytics

import Analytics from './analytics';
new Analytics();


$(document).on('opened.zf.offCanvas', '#menu-canvas', function (e) {
    $('.c-offcanvas-nav__button').addClass('open');
});

$(document).on('closed.zf.offCanvas', '#menu-canvas', function (e) {
    $('.c-offcanvas-nav__button').removeClass('open');
});


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *	process link tags
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

$('body').on('click', 'a', function (e) {
    let href = $(this).attr('href');

    // scroll to id if hash link clicked
    if (href !== undefined && href.charAt(0) === '#' && href.length > 1 && $(href).length) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: ($(href).offset().top - 13)
        }, 1000);
        return false;
    }

    return true;
});

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *	scroll up activation and initialising gallery
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

$(document).ready(function () {
    let $item = $('.c-scroll-up');
    let fade = 1;
    $(window).scroll(function () {
        $item.each(function () {
            if (($(window).scrollTop() > 400) && (fade > 0)) {
                $(this).fadeIn(function () {
                    fade = 0;
                });
            }
            if (($(window).scrollTop() < 100) && (fade === 0)) {
                $(this).fadeOut(function () {
                    fade = 1;
                });
            }
        });
    });

    $('[data-modaalimage]').modaal({
        type: 'image'
    });
});
